import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const News = () => {
  const newsItems = [
    {
      id: 1,
      title: 'New UK Gambling Regulations Take Effect: What Players Need to Know',
      date: '29.11.2025',
      excerpt: 'Recent updates to UK gambling laws introduce enhanced player protections and stricter operator requirements. Here\'s how these changes affect your gaming experience.',
      image: '/images/esteban-lopez-UIvRqbmtlFU-unsplash.webp',
    },
    {
      id: 2,
      title: 'Top 5 Slot Games Dominating UK Casinos This Month',
      date: '25.11.2025',
      excerpt: 'From classic fruit machines to modern video slots, discover which games are paying out the most and attracting the biggest player bases across UK platforms.',
      image: '/images/krissia-cruz-FwPzGn59wNs-unsplash.webp',
    },
    {
      id: 3,
      title: 'Cryptocurrency Payments Gain Traction in UK Online Casinos',
      date: '20.11.2025',
      excerpt: 'More UK casinos are embracing crypto deposits and withdrawals. We break down which operators offer Bitcoin, Ethereum, and other digital currencies, plus the pros and cons.',
      image: '/images/lee-thomas-BjIALEkr_Wg-unsplash.webp',
    },
  ];

  return (
    <section id="news" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-dark text-center mb-12">
          Latest Casino News
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {newsItems.map((news, index) => (
            <article
              key={news.id}
              itemScope
              itemType="https://schema.org/NewsArticle"
              className={`bg-white rounded-xl shadow-lg overflow-hidden transition-all transform hover:scale-105 hover:shadow-2xl ${
                index === 0 ? 'md:col-span-1 border-2 border-yellow-accent' : ''
              }`}
            >
              <div 
                className="h-48 bg-cover bg-center"
                style={{ backgroundImage: `url(${news.image})` }}
                itemProp="image"
              ></div>
              
              <div className="p-6">
                <div className="flex items-center space-x-2 text-sm text-gray-light mb-3">
                  <Calendar size={16} />
                  <time dateTime={news.date.split('.').reverse().join('-')} itemProp="datePublished">{news.date}</time>
                </div>
                
                <h3 className="text-xl font-bold text-gray-dark mb-3 leading-tight" itemProp="headline">
                  {news.title}
                </h3>
                
                <p className="text-gray-light mb-4 leading-relaxed" itemProp="description">
                  {news.excerpt}
                </p>
                
                <Link
                  to={`/news/${news.id === 1 ? 'uk-gambling-regulations' : news.id === 2 ? 'top-slot-games' : 'cryptocurrency-payments'}`}
                  data-discover="true"
                  className="inline-flex items-center space-x-2 text-yellow-accent font-semibold hover:text-yellow-light transition-colors"
                >
                  <span>Read More</span>
                  <ArrowRight size={16} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;

